module.exports = __webpack_public_path__ + "img/GS_Profile-Sharmelle Rugan.e970cebe.png";